import { ColumnsType } from 'antd/es/table';
import { EnterpriseActions } from './EnterpriseActions/EnterpriseActions';
import { t } from 'i18next';
import { getUTCTableDateFormat } from '@/shared/utils';
import {
  CreateEnterpriseFrameworkDto,
  Enterprise,
} from '@/stores/EnterpriseStore/EnterpriseStore.consts';
import { FRAMEWORK_TITLES } from '@/shared/consts';
import { convertFrameworksToText } from './EnterprisesTable.utils';

export type EnterpriseDataType = {
  key: string;
  id: string;
  name: string;
  description: string;
  emails: string;
  frameworks: string;
  expiresAt: Date;
  createdAt: Date;
  updatedAt: Date;
  actions: string;
};

export const getColumns = (): ColumnsType<EnterpriseDataType> => [
  {
    title: `${t('admin.table.date')} (UTC)`,
    key: 'createdAt',
    render: (enterprise: Enterprise) => getUTCTableDateFormat(enterprise.createdAt),
  },
  {
    title: t('admin.table.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: t('admin.table.description'),
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: t('admin.table.emails'),
    key: 'emails',
    render: (enterprise: Enterprise) => enterprise.emails.join(', '),
  },
  {
    title: t('admin.table.frameworks'),
    key: 'frameworks',
    render: (enterprise: Enterprise) => (
      <div style={{ whiteSpace: 'pre-line' }}>{convertFrameworksToText(enterprise.frameworks)}</div>
    ),
  },
  {
    title: `${t('admin.table.expires_at')} (UTC)`,
    key: 'expiresAt',
    render: (enterprise: Enterprise) =>
      enterprise.expiresAt
        ? getUTCTableDateFormat(enterprise.expiresAt)
        : t('admin.table.no_expiration'),
  },
  {
    key: 'actions',
    render: (enterprise: Enterprise) => {
      return <EnterpriseActions enterprise={enterprise} />;
    },
  },
];
